import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ITerminalFormMeta {
    number: FormInputMeta;
    name: FormInputMeta;
    bank: FormInputMeta;
    status: FormInputMeta;
    mode: FormInputMeta;
    eventLevel: FormInputMeta;
    agency: FormInputMeta;
    family: FormInputMeta;
    group: FormInputMeta;
    protocol: FormInputMeta;
    configuration: FormInputMeta;

    schema: any;
}

const terminalFormMeta = {} as ITerminalFormMeta;

terminalFormMeta.number = {
    name: "number",
    type: "text",
    label: "Num.",
    placeholder: "Num.",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.name = {
    name: "name",
    type: "text",
    label: "Nom",
    placeholder: "Nom",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.bank = {
    name: "bank",
    type: "text",
    label: "Banque",
    placeholder: "Banque",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.status = {
    name: "status",
    type: "text",
    label: "Statut",
    placeholder: "Statut",
    validation: yup.string()
};

terminalFormMeta.mode = {
    name: "mode",
    type: "text",
    label: "Mode",
    placeholder: "Mode",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.eventLevel = {
    name: "eventLevel",
    type: "select",
    label: "Niveau Evene.",
    placeholder: "Niveau Evene.",
    validation: yup.string()
};

terminalFormMeta.agency = {
    name: "agency",
    type: "select",
    label: "Agence",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.family = {
    name: "family",
    type: "select",
    label: "Famille",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.group = {
    name: "group",
    type: "select",
    label: "Groupe",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.protocol = {
    name: "protocol",
    type: "select",
    label: "Protocole",
    validation: yup.string().required("Champ obligatoire !")
};

terminalFormMeta.configuration = {
    name: "configuration",
    type: "select",
    label: "Configuration",
    validation: yup.string().required("Champ obligatoire !")
};


terminalFormMeta.schema = yup.object().shape(getValidationSchema(terminalFormMeta));

export default terminalFormMeta;